import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SubscriptionStatus } from '~myAccount/enums';
import { useFullRoutes } from '~/hooks';
import { useReactivateSubscriptionMutation } from '~/redux/api/subscriptionApiSlice';

export default function SubscriptionCta({
  status,
  planId,
  id,
}: {
  status: SubscriptionStatus;
  planId: number;
  id: number;
}) {
  const { t } = useTranslation('app');
  const { SUBSCRIPTION_URL } = useFullRoutes();
  const [reactivateSubscription, { isLoading }] =
    useReactivateSubscriptionMutation();

  const handleReactivate = async () => {
    try {
      await reactivateSubscription(id).unwrap();
    } catch (error) {
      // TODO: Handle error, e.g., show a toast notification
      console.error('Failed to reactivate subscription:', error);
    }
  };

  return status === SubscriptionStatus.GRACE_PERIOD ? (
    <button
      className="flex element-center gap-0.5x text-link text-blue bg-transparent  "
      onClick={handleReactivate}
    >
      {isLoading && <span className="loading loading-spinner"></span>}
      {t('reactivate')}
    </button>
  ) : status !== SubscriptionStatus.ACTIVE ? (
    <Link
      to={SUBSCRIPTION_URL.CHECKOUT(planId)}
      className="text-link text-blue "
    >
      {t('reSubscribe')}
    </Link>
  ) : null;
}
